'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BetaSticker;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

require('../styles/BetaSticker.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BetaSticker() {
  return _react2.default.createElement(
    'span',
    { className: 'cp-beta-sticker' },
    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'public_beta' })
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/beta-sticker/components/BetaSticker.component.js
// module id = 1278
// module chunks = 0